import type { SVGProps } from 'react'
const SvgSyTimeAtack = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<circle cx={12} cy={12} r={9} fillOpacity={0.24} />
		<path d="M12 5.3c0-.143 0-.214.046-.258.047-.044.116-.042.254-.036a7 7 0 1 1-6.207 10.75c-.074-.116-.111-.175-.096-.237s.077-.098.2-.169l5.653-3.263c.073-.043.11-.064.13-.099s.02-.077.02-.161z" />
	</svg>
)
export default SvgSyTimeAtack
